/* @flow */
import { Map } from 'immutable';
import {
  FETCH,
  FETCH_QUOTAS,
  UPDATE,
  UPDATE_PREFERENCES,
  SAVE_PASSWORD,
  HIDE_UPSELL_MODAL,
} from './action-types.js';
import {PREMIUM_CONTENT_LOCK_CLICK} from './action-types';

export const fetch = (): Object => ({ type: FETCH });

export const fetchQuotas = (): Object => ({ type: FETCH_QUOTAS });

export const savePassword = (currentPassword: string, newPassword: string) => ({
  type: SAVE_PASSWORD,
  payload: { currentPassword, newPassword },
});

export const update = (profile: Object | Map<any, any>) => ({
  type: UPDATE,
  payload: profile,
});

export const updatePreferences = (preferences: Object | Map<any, any>) => ({
  type: UPDATE_PREFERENCES,
  payload: preferences
});

export const hideUpsellModal = () => ({
  type: HIDE_UPSELL_MODAL,
});

export const premiumContentLockClick = (payload: Object) => ({
  type: PREMIUM_CONTENT_LOCK_CLICK,
  payload
});


// WEBPACK FOOTER //
// ./src/app/modules/profile/actions.js